export default __webpack_public_path__ + "static/media/keto_breath@3x.75ff65b9.jpg";